/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $AppealTopic = {
    properties: {
        name: {
            type: 'string',
        },
        id: {
            type: 'number',
            format: 'double',
        },
    },
};